module.exports = __webpack_public_path__ + "img/PrincipalSign.1588069e.png";